import { AppCard } from '../../../components/AppCard';
import { SingleQueryResults } from '../../../components/QueryResults/SingleQueryResults';
import { useActiveWorkspace } from '../../../hooks/useActiveWorkspace';
import type {
  RoyaltiesRegion,
  RoyaltiesSection,
} from '../../../layout/royaltiesLayoutConfig';
import { workspaceTypeIsAgent } from '../../../utils/helpers/common';
import { RoyaltiesListTable } from './RoyaltiesListTable';

interface RoyaltiesTabPageProps {
  product: RoyaltiesRegion;
  section: RoyaltiesSection;
}

/**
 * Mounts a tab's table only once the active workspace query has settled.
 * `product` and `section` are fixed per route, so neither the region nor the
 * title/earnings hook swaps under a live mount.
 */
const RoyaltiesTabPage = ({ product, section }: RoyaltiesTabPageProps) => {
  const [, activeWorkspaceQuery] = useActiveWorkspace();

  return (
    <SingleQueryResults query={activeWorkspaceQuery}>
      {(workspace) => (
        <AppCard className="gap-5">
          <RoyaltiesListTable
            isAgent={workspaceTypeIsAgent(workspace)}
            product={product}
            section={section}
            workspaceId={workspace._id}
          />
        </AppCard>
      )}
    </SingleQueryResults>
  );
};

/** Royalties ANZ — Title Statements tab (all current members). */
export const RoyaltiesAnzTitleStatements = () => (
  <RoyaltiesTabPage product="anz" section="title-statements" />
);

/** Royalties ANZ — Earnings Statements tab (all current members). */
export const RoyaltiesAnzEarningsStatements = () => (
  <RoyaltiesTabPage product="anz" section="earnings-statements" />
);

/** Royalties World — Title Statements tab (all current members). */
export const RoyaltiesWorldTitleStatements = () => (
  <RoyaltiesTabPage product="world" section="title-statements" />
);

/** Royalties World — Earnings Statements tab (all current members). */
export const RoyaltiesWorldEarningsStatements = () => (
  <RoyaltiesTabPage product="world" section="earnings-statements" />
);
